import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';

export default function NavBarRegister() {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  return (
    <>
      {!isMobile && (
        <Box sx={{ flexGrow: 1 }}>
          <AppBar
            sx={{
              background: 'transparent',
              boxShadow: 'none',
              padding: { xs: '24px 44px', md: '34px 90px' },
            }}
          >
            <Toolbar
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              <Link to={'/auth'}>
                <Box
                  component="img"
                  margin="15px"
                  sx={{
                    height: { xs: '33px' },
                    width: { xs: '180px' },
                    objectFit: 'contain',
                  }}
                  alt="Your logo."
                  src="/FinowLogoWhite.svg"
                />
              </Link>
            </Toolbar>
          </AppBar>
        </Box>
      )}
    </>
  );
}
